import React, { useState, createContext, useContext } from 'react';
import moment from 'moment';
import { AuthenticationContext } from '../authentication/authentication.context';

export const DateTimeContext = createContext();

export const DateTimeContextProvider = ({ children }) => {
  const { userPreferTime } = useContext(AuthenticationContext);
  //state
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [timeZone, setTimeZone] = useState('');

  const setState = (meeting) => {
    const convertDateTime = (date) => {
      return moment
        .utc(date)
        .clone()
        .tz(timeZone)
        .format('YYYY-MM-DDTHH:mm');
    };

    if(meeting) {
      setTimeZone(meeting.time_zone);
      setStartDate(meeting.date_time);
      setEndDate(meeting.end_date_time);
    } else {
      userPreferTime && setTimeZone(userPreferTime.user_timezone)
      timeZone && setStartDate(convertDateTime(meeting.date_time));
      timeZone && setEndDate(convertDateTime(meeting.end_date_time));
    }

  };

  //create meeting
  const convertToUTC = (date, timeZone) => {
    let format = moment(date).format('YYYY-MM-DDTHH:mm');
    let convertDateTime = moment.tz(format, timeZone);
    return convertDateTime.utc().format();
  };

  const formatStartDate = (date) => {
    return moment(date).format('YYYY-MM-DDTHH:mm');
  };

  const formatEndDate = (date) => {
    return moment(date).add(60, 'm').format('YYYY-MM-DDTHH:mm');
  };

  const startDateChange = (date, id) => {
    setStartDate(formatStartDate(date));
    !id && localStorage.setItem('startDate', formatStartDate(date));

    if (endDate <= formatStartDate(date)) {
      setEndDate(formatEndDate(date));
      !id && localStorage.setItem('endDate', formatEndDate(date));
    }
  };

  const endDateChange = (date, id) => {
    if (startDate >= formatEndDate(date)) {
      setEndDate(formatEndDate(startDate));
      !id && localStorage.setItem('endDate', formatEndDate(date));
    } else {
      //if end date grater than start date
      setEndDate(formatStartDate(date));
      !id && localStorage.setItem('endDate', formatStartDate(date));
    }
  };

  const timeZoneChange = (timeZone, id) => {
    setTimeZone(timeZone);
    !id && localStorage.setItem('timeZone', timeZone);
  };

  return (
    <DateTimeContext.Provider
      value={{
        timeZone,
        startDate,
        endDate,
        setTimeZone,
        setStartDate,
        setEndDate,
        convertToUTC,
        setState,
        startDateChange,
        endDateChange,
        timeZoneChange,
      }}
    >
      {children}
    </DateTimeContext.Provider>
  );
};
